import axios from "axios";
import config from "../config"; // Đảm bảo bạn có file này định nghĩa apiBaseUrl

export const getDashboardData = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${config.apiBaseUrl}/Dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("❌ Lỗi khi lấy dữ liệu dashboard:", error);
    throw error;
  }
};
